import SupplierList from '@/views/repository/supplier-list.vue';
import RepositoryList from '@/views/repository/repository-list.vue';
import RepositoryDetail from '@/views/repository/repository-detail.vue';
import PrinterList from '@/views/repository/printer-list.vue';
import PrinterDetail from '@/views/repository/components/printer-detail.vue';
import ProxyList from '@/views/repository/proxy-list.vue';
import ProxyDetail from '@/views/repository/components/proxy-detail.vue';
export default [
    {
        path: '/supplier/supplier-list',
        component: SupplierList,
        name: 'supplierList'
    },
    {
        path: '/repository/repository-list',
        component: RepositoryList,
        name: 'repositoryList'
    },
    {
        path: '/repository/repository-detail',
        component: RepositoryDetail,
        name: 'repositoryDetail'
    },
    {
        path: '/repository/printer-list',
        component: PrinterList,
        name: 'printerList'
    },
    {
        path: '/repository/printer-detail',
        component: PrinterDetail,
        name: 'printerDetail'
    },
    {
        path: '/repository/proxy-list',
        component: ProxyList,
        name: 'proxyList'
    },
    {
        path: '/repository/proxy-detail',
        component: ProxyDetail,
        name: 'proxyDetail'
    },

]